export const TYPE_OPTIONS = [
	{ id: 'PROMOTIONAL', label: 'PROMOTIONAL' },
	{ id: 'SALES', label: 'SALES' },
	{ id: 'MISCELLANEOUS', label: 'MISCELLANEOUS' }
];

export const LOCATION_OPTIONS = [
	{ id: 'WALLET', label: 'WALLET' },
	{ id: 'HOME_SCREEN', label: 'HOME_SCREEN' },
	{ id: 'WITHDRAWAL', label: 'WITHDRAWAL' }
];

export const SEGMENT_INSTRUCTION_OPTIONS = [
	{ id: 'INCLUDE', label: 'INCLUDE' },
	{ id: 'EXCLUDE', label: 'EXCLUDE' }
];

export const CTA_TYPE_OPTIONS = [
	{ id: 'IN_APP', label: 'IN_APP' },
	{ id: 'EXTERNAL_LINK', label: 'EXTERNAL_LINK' },
	{ id: 'WEBVIEW_LINK', label: 'WEBVIEW_LINK' }
];

export const CTA_VALUE_OPTIONS = [
	{ id: 'DASHBOARD', label: 'DASHBOARD' },
	{ id: 'PLAY_ONLINE', label: 'PLAY_ONLINE' },
	{ id: 'PROFILE', label: 'PROFILE' },
	{ id: 'REFER', label: 'REFER' },
	{ id: 'SETTINGS', label: 'SETTINGS' },
	{ id: 'WALLET', label: 'WALLET' },
	{ id: 'WITHDRAWAL', label: 'WITHDRAWAL' },
	{ id: 'KYC', label: 'KYC' },
	{ id: 'HOW_TO_PLAY', label: 'HOW_TO_PLAY' },
	{ id: 'ADD_MONEY', label: 'ADD_MONEY' },
	{ id: 'NOTIFICATION', label: 'NOTIFICATION' },
	{ id: 'HELPDESK', label: 'HELPDESK' },
	{ id: 'GAME_MANAGEMENT', label: 'GAME_MANAGEMENT' },
	{ id: 'ADD_BANK', label: 'ADD_BANK' },
	{ id: 'ADD_UPI', label: 'ADD_UPI' },
	{ id: 'MTT_TOURNAMENT', label: 'MTT_TOURNAMENT' },
	{ id: 'CONTEST', label: 'CONTEST' },
	{ id: 'NUDGE', label: 'NUDGE' },
	{ id: 'TELEGRAM_REFERRAL', label: 'TELEGRAM_REFERRAL' },
	{ id: 'WHATSAPP_SHARE', label: 'WHATSAPP_SHARE' },
	{ id: 'DAILY_CHALLENGE', label: 'DAILY_CHALLENGE' },
	{ id: 'APP_RESTART', label: 'APP_RESTART' },
	{ id: 'TRANSACTION_HISTORY', label: 'TRANSACTION_HISTORY' },
	{ id: 'PWF', label: 'PWF' },
	{ id: 'PAYMENTS', label: 'PAYMENTS' },
	{ id: 'SOCIAL_COMMUNITY', label: 'SOCIAL_COMMUNITY' },
	{ id: 'SOCIAL_EDIT_PROFILE', label: 'SOCIAL_EDIT_PROFILE' },
	{ id: 'NX_DETAILS', label: 'NX_DETAILS' },
	{ id: 'NX_LEADERBOARD', label: 'NX_LEADERBOARD' },
	{ id: 'NX_GAME_HISTORY', label: 'NX_GAME_HISTORY' },
	{ id: 'NX_SYNC_DETAILS', label: 'NX_SYNC_DETAILS' },
	{ id: 'NX_SYNC_LEADERBOARD', label: 'NX_SYNC_LEADERBOARD' },
	{ id: 'TDS_CERTIFICATES', label: 'TDS_CERTIFICATES' },
	{ id: 'TDS_INFO', label: 'TDS_INFO' },
	{ id: 'VIEW_ALL_FRIENDS', label: 'VIEW_ALL_FRIENDS' },
	{ id: 'TESTIMONIAL_VIDEO', label: 'TESTIMONIAL_VIDEO' },
	{ id: 'RG_HOME', label: 'RG_HOME' },
	{ id: 'RG_LOSS_LIMIT_CONFIRM', label: 'RG_LOSS_LIMIT_CONFIRM' },
	{ id: 'RAKEBACK_LEADERBOARD', label: 'RAKEBACK_LEADERBOARD' },
	{ id: 'RAKEBACK_LEADERBOARD_DETAILS', label: 'RAKEBACK_LEADERBOARD_DETAILS' },
	{ id: 'PARTNER_COUPON', label: 'PARTNER_COUPON' },
	{ id: 'VIP', label: 'VIP' },
	{ id: 'DICE', label: 'DICE' },
	{ id: 'VIP_REWARD_HISTORY', label: 'VIP_REWARD_HISTORY' },
	{ id: 'VIP_SPLASH', label: 'VIP_SPLASH' },
	{ id: 'VIP_REWARDS_COLLECTION', label: 'VIP_REWARDS_COLLECTION' },
	{ id: 'CONVERT_TO_DEPOSIT', label: 'CONVERT_TO_DEPOSIT' },
	{ id: 'GENERIC_WEBVIEW', label: 'GENERIC_WEBVIEW' }
];

export const LANG_OPTIONS = [
	{ id: 'en', label: 'ENGLISH' },
	{ id: 'hi', label: 'HINDI' }
];

export const LOCATION_IMAGE_RATIO_MAP: { [id: string]: number } = {
	WALLET: 3,
	HOME_SCREEN: 4
};

export enum EBannerLocation {
	HOME_SCREEN = 'HOME_SCREEN',
	WALLET = 'WALLET',
	WITHDRAWAL = 'WITHDRAWAL'
}

export interface UserlistData {
	bannerId: string;
	uids: File;
}
